
/*
Sometimes we get data with explicit nulls.
This can cause issues (not least with destructuring), so lets have a function
that strips them out.

*/
export function noNullDeepClone(srcObject) {
  let cloned;

  function copy(key) {
    const {[key]: value} = srcObject;

    if ((value !== null) && (value !== undefined)) {
      if (typeof value == "object") {
        cloned[key] = noNullDeepClone(value);
      }
      else {
        cloned[key] = value;
      }
    }
  }

  if (srcObject instanceof Array) {
    const {length} = srcObject;
    cloned = Array(length);

    srcObject.forEach((v, key) => copy(key));
  }
  else if (srcObject instanceof Object) {
    cloned = {};

    Object.keys(srcObject).forEach(key => copy(key));
  }
  else {
    cloned = srcObject;
  }

  return cloned;
}


/*
The Webpack CSS loader can read exports from the CSS. It returns an object, flattening the keys with dashes as necessary;

The values are Strings exactly from the CSS, so to allow types, they should be JSON encoded (ie the CSS should closely resemble JS)

eg starting with this in "my.scss";

:export {
  count: 1;
  names: {
    bob: "Robert Smith";
    alice: "Alice Jones";
  }
}

calling parseCssExports(require("my.scss")) will yeild;

{
  "count": 1,
  "names-bob": "Robert Smith",
  "names-alice": "Alice Jones"
}

Without the quotes in the CSS, the parse would throw an error.

Is is possible to override the JSON.parse default behaviour by passing in an alternative transform option.

So calling parseCssExports(require("my.scss"), {transform: v => v}) on the above example source CSS will yeild;

{
  "count": "1",
  "names-bob": "\"Robert Smit\"",
  "names-alice": "\"Alice Jones\""
}

If a prefix option is given, only those keys that started with the prefix (dash separated from the rest) give values
in the result, with the prefix stripped from the key.

So calling parseCssExports(require("my.scss"), {prefix: "names"}) on the above example source CSS will yeild;

{
  "bob": "Robert Smith",
  "alice": "Alice Jones"
}

Note that you have to call require with a string, or it will not work.


*/
export function parseCssExports(sourceObj, {prefix, transform = JSON.parse} = {}) {
  let parsedValues = Object.keys(sourceObj);

  if (prefix) {
    parsedValues = parsedValues.filter(k => (k.substring(0, prefix.length + 1) == `${prefix}-`));
  }

  parsedValues = parsedValues
    .map(k => [k, prefix && k.substring(prefix.length + 1)])
    .reduce((o, [srcKey, parsedKey]) => ({
      ...o,
      [parsedKey || srcKey]: transform(sourceObj[srcKey])
    }), {});

  return parsedValues;
}

const globalExports = require('sass/sportinglife.scss');

export function globalCssExports(prefix) {
  return parseCssExports(globalExports, {prefix});
}


// Use this to wrap an href in a <Link to> to prevent the scroll to top behaviour for that link
export function preventLinkScroll(href) {
  return {
    pathname: href,
    state: {
      preventScroll: true
    }
  };
}

export function getSection([, {path = "home"} = {}] = []) { // arg is routes array
  return path;
}

export function buildPath(routes = []) {
  return routes.reduce((fullPath, {path = ''}) =>
    path ? `${fullPath}/${path}` : fullPath
  , '/').replace(/\/{2,}/, '/');
}


export function consumerUrl() {
  const {origin, protocol, hostname, port} = window.location;

  var out = origin || `${protocol}//${hostname}${port?`:${port}`:''}`;

  if (out.endsWith(".dev")){
      return out.replace(".dev", ".com");
  }

  return out;
}

// Simple decoder for a flat list fo URL query string params as they exist *right now*
// The params that started this session (but need not still be there) are stored in Redux
export function getDecodedQueryString() {
  const {
    location: {
      search = ""
    } = {},
    decodeURIComponent = i => i
  } = global;

  return search.substring(1).split("&").reduce((o, pair) => {
    const [key, value = ""] = pair.split("=");

    if (key) {
      return {...o, [key]: decodeURIComponent(value.replace(/\+/g, "%20"))}
    }

    return o;
  }, {});
}

// Actions are query string params that some buttons can look for
// The key is the action name, and the value is the required action params, separated by |
// eg a subscription button can look for params like ?subscribe=TYPE|id (eg ?subscribe=HORSE|1234)
export function getActionParam(action) {
  const {[action]: value = ""} = getDecodedQueryString();
  return value.split("|");
}

const MOBILE_APP_BROWSER_AGENT_IDENTIFIER = "Sky SportingLife Mobile App";

export function isMobileApp(agent) {
  return agent && agent.toLowerCase().indexOf(MOBILE_APP_BROWSER_AGENT_IDENTIFIER.toLowerCase()) >= 0;
}

const BASE_SSO_REDIRECT_URL = "https://www.skybet.com/secure/identity/referral/";

export function getXsellUrl(referralUrl, ssoConsumer) {
    return ssoConsumer ? `${BASE_SSO_REDIRECT_URL}${ssoConsumer}?referralUrl=${encodeURIComponent(referralUrl)}` : referralUrl;
}



// WEBPACK FOOTER //
// ./utils/commonUtils.js